import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import {
  CloseEventModalOrigin,
  InfoModalVariant,
  InfoModalComponent,
  ModalService,
} from '@circlek-global/lds-components';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-modal',
  imports: [InfoModalComponent, TranslateModule],
  providers: [ModalService],
  templateUrl: './modal-base.component.html',
})
export class ModalBaseComponent {
  isOpen = signal<boolean>(false);
  @Input() modalType!: InfoModalVariant;
  @Input() titleTransKey!: string;
  @Input() infoTextTransKey!: string;
  @Input() confirmBtnTextTransKey!: string;
  @Input() cancelBtnTextTransKey!: string;
  @Input() isCancelBtnHidden!: boolean;
  @Output() onButtonClose = new EventEmitter();
  @Output() onButtonConfirm = new EventEmitter();

  openModal() {
    this.isOpen.set(true);
  }

  onModalClose(decision: CloseEventModalOrigin) {
    if (decision == CloseEventModalOrigin.SUBMIT) {
      this.onButtonConfirm.emit();
    } else {
      this.onButtonClose.emit();
    }

    this.isOpen.set(false);
  }
}
